import AlertErrorOutline from 'material-ui/svg-icons/alert/error-outline'
import NavigationCheck from 'material-ui/svg-icons/navigation/check'
import RemoveCircle from 'material-ui/svg-icons/content/remove-circle-outline'
import FontIcon from 'material-ui/FontIcon'

export default class SeoHelpers {
  static severityIcon(verdict) {
    verdict = verdict.toLowerCase()

    // Achievement, Pass = green tick
    // Information, Warning = exclamation mark
    // Critical = red cross

    let ligature = 'sync'

    if (verdict == 'achievement' || verdict == 'pass')
      ligature = 'check'
    else if (verdict == 'information' || verdict == 'warning')
      ligature = 'warning'
    else //critical
      ligature = 'close'

    return (
      <FontIcon className="material-icons" style={{ display: 'block', textAlign: 'center', color: 'inherit' }}>
        { ligature }
      </FontIcon>
    )
  }

  static severityColor(verdict, theme) {
    // Green
    // NoIssuesNoUserActionRequired = 0,
    // MinorIssuesUneconomicalForUserToFix = 1,
    // Yellow
    // IssuesUserShouldConsiderFix = 2,
    // Red
    // MajorIssuesUserShouldFix = 3

    if (!verdict || !theme)
      return {
        background: '#FFFFFF',
        foreground: '#000000',
        foregroundFaded: '#000000',
        default: true
      }

    if (verdict == 'NoIssuesNoUserActionRequired' || verdict == 'MinorIssuesUneconomicalForUserToFix')
      return { background: theme.palette.green, foreground: theme.palette.foregroundWhite, foregroundFaded: theme.palette.foregroundWhiteFaded }
    else if (verdict == 'IssuesUserShouldConsiderFix')
      return { background: theme.palette.yellow, foreground: theme.palette.foregroundBlack, foregroundFaded: theme.palette.foregroundBlackFaded }
    else //critical
      return { background: theme.palette.red, foreground: theme.palette.foregroundWhite, foregroundFaded: theme.palette.foregroundWhiteFaded }
  }
}



// WEBPACK FOOTER //
// ./app/helpers/SeoHelpers.js